<template>
    <div class="settings">
        <layout>
            <md-app-content v-if="loaded && location">
                <form class="md-layout" @submit.prevent="submit">

          <h2 class="settings__title">Allgemein</h2>
          <div class="settings__card">
            <div class="settings__field">
              <md-field>
                <label for="mwst">Globale Mehrwersteuer in Prozent</label>
                <md-input type="number" step="0.01"  name="mwst" id="mwst" v-model="item.mwst" required/>
              </md-field>
            </div>
          </div>


                    <h2 class="settings__title">Infotexte</h2>
                    <div class="settings__card">
                        <div class="settings__field">
                            <md-field required>
                                <label for="placed_text">placed_text</label>
                                <md-textarea name="placed_text" id="placed_text" v-model="item.placed_text" md-autogrow
                                             required/>
                            </md-field>
                        </div>
                        <div class="settings__field">
                            <md-field required>
                                <label for="ready_text">ready_text</label>
                                <md-textarea name="ready_text" id="ready_text" v-model="item.ready_text" md-autogrow
                                             required/>
                            </md-field>
                        </div>
                        <div class="settings__field">
                            <md-field required>
                                <label for="picked_up_text">picked_up_text</label>
                                <md-textarea name="picked_up_text" id="picked_up_text" v-model="item.picked_up_text"
                                             md-autogrow required/>
                            </md-field>
                        </div>
                        <div class="settings__field">
                            <md-field required>
                                <label for="canceled_text">canceled_text</label>
                                <md-textarea name="canceled_text" id="canceled_text" v-model="item.canceled_text"
                                             md-autogrow required/>
                            </md-field>
                        </div>
                        <div class="settings__field">
                            <md-field required>
                                <label for="idle_text">idle_text</label>
                                <md-textarea name="idle_text" id="idle_text" v-model="item.idle_text" md-autogrow
                                             required/>
                            </md-field>
                        </div>
                        <div class="settings__field">
                            <md-field required>
                                <label for="idle_text">ordered_text</label>
                                <md-textarea name="ordered_text" id="ordered_text" v-model="item.ordered_text"
                                             md-autogrow required/>
                            </md-field>
                        </div>
                        <div class="settings__field">
                            <md-field required>
                                <label for="idle_text">serving_text</label>
                                <md-textarea name="serving_text" id="serving_text" v-model="item.serving_text"
                                             md-autogrow required/>
                            </md-field>
                        </div>
                        <div class="settings__field">
                            <md-field required>
                                <label for="idle_text">served_text</label>
                                <md-textarea name="served_text" id="served_text" v-model="item.served_text" md-autogrow
                                             required/>
                            </md-field>
                        </div>
                    </div>

          <h2 class="settings__title">Verfügbarkeit</h2>
          <div class="settings__card">
            <div class="settings__field">
              <md-switch v-model="item.open_on_idle" class="md-primary">Service dauerhaft aktivieren <br><small>(Standartmässig wird der Service beim Schliessen oder Abmelden des Merchants pausiert)</small></md-switch>
            </div>
          </div>

          <div class="settings__button">
            <button type="submit" :disabled="!validated" class="button">Änderungen speichern</button>
          </div>
        </form>
            </md-app-content>
        </layout>

        <snackbar></snackbar>

    </div>
</template>

<script>
    import {mapGetters, mapActions} from 'vuex'
    import Layout from '../components/Layout'
    import Snackbar from '../components/Snackbar'

    export default {
        components: {
            Layout,
            Snackbar
        },
        name: 'settings',
        data() {
            return {
                item: {
                    placed_text: '',
                    ready_text: '',
                    picked_up_text: '',
                    canceled_text: '',
                    idle_text: '',
                    ordered_text: '',
                    serving_text: '',
                    served_text: '',
                    mwst: null,
                    open_on_idle: false,
                }
            }
        },
        computed: {
            ...mapGetters('dashboard', [
                'loaded',
                'location'
            ]),
            validated: function () {
                return (this.item.placed_text && this.item.picked_up_text && this.item.picked_up_text && this.item.canceled_text && this.item.idle_text && this.item.mwst)
            },
            showErrorMessage: function () {
                return this.error && this.showSnackbar
            }
        },
        watch: {
            'location': function () {
                this.setData()
            }
        },
        methods: {
            ...mapActions('dashboard', [
                'updateLocation'
            ]),
            setData: function () {
                this.item.placed_text = this.location.placed_text
                this.item.ready_text = this.location.ready_text
                this.item.picked_up_text = this.location.picked_up_text
                this.item.canceled_text = this.location.canceled_text
                this.item.idle_text = this.location.idle_text
                this.item.ordered_text = this.location.ordered_text
                this.item.serving_text = this.location.serving_text
                this.item.served_text = this.location.served_text
                let tmpMwst = this.location.mwst * 100
                this.item.mwst = tmpMwst.toFixed(2)
                this.item.open_on_idle = (this.location.open_on_idle === 1)
            },
            submit: async function () {
                let data = {
                    id: this.location.id,
                    item: this.item
                }
                this.updateLocation(data)
            }
        }
    }
</script>
